/* eslint-disable no-bitwise */
import { get } from './fetch'

export const createFlowToken = (token?: string): string => {
  let flowToken
  if (token) {
    flowToken = token
  } else {
    let d = new Date().getTime()
    flowToken = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
  }
  return flowToken
}
export type SessionData = {
  accessToken: string
  csrfToken: string
  featureFlagsJson: string
}
// Allow connecting development to staging server
export const getServerGeneratedProperties = (path = '/fake-server-properties'): Promise<void> =>
  get<SessionData>(path).then(sessionData => {
    window.csrfToken = sessionData.csrfToken
    window.accessToken = sessionData.accessToken

    const featureFlagsJson = JSON.parse(sessionData.featureFlagsJson)
    if (typeof window.featureFlagsJson === 'object') {
      window.featureFlagsJson = { ...featureFlagsJson, ...window.featureFlagsJson }
    } else {
      window.featureFlagsJson = featureFlagsJson
    }
    window.featureFlagsJson = JSON.parse(sessionData.featureFlagsJson)
  })
